export const INTERACTIVE_FEED_PAGE_SIZE = 30;
export const GRID_VIRTUALIZER_OVERSCAN_ROWS = 2;

export const SUPPORTED_GRID_COLUMN_COUNTS = [1, 2, 3] as const;

export const getVirtualRowTranslateY = (start: number, scrollMargin: number) => (
  Math.max(0, start - scrollMargin)
);
